import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IIncidentUpdateRequestDetails } from "../../../api/Incident/IIncidentUpdateRequestDetails";
import { ILicenceProfile } from "../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  incidentUpdateRequestDetails: IIncidentUpdateRequestDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  incidentUpdateRequestDetails,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        {incidentUpdateRequestDetails.incidentDetails && (
          <Breadcrumb.Item
            href={`/licence-profile/${licenceProfile.profileNo}/compliance/incident/${incidentUpdateRequestDetails.incidentid}`}
          >
            {incidentUpdateRequestDetails.incidentDetails?.reference}
          </Breadcrumb.Item>
        )}
        <Breadcrumb.Item active>Incident Update Request</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
